import { ManageQuestionsEditAnswersPage } from './manage-questions-edit-answers.page';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    component: ManageQuestionsEditAnswersPage,
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ManageQuestionsEditAnswersPageRoutingModule {}
